import React from "react";
import "./Header.css";
import LogoDarkMode from "../../assets/icons/NavbarLogoDesktopDark.svg";
import LogoLightMode from "../../assets/icons/NavbarLogoDesktop.svg";
import LogoMobile from "../../assets/icons/NavbarLogoMobile.svg";
import IdeaValidator from "../../assets/icons/IdeaValidator.svg";
import MarketInsights from "../../assets/icons/MarketInsights.svg";
import PitchDeckAnalyzer from "../../assets/icons/PitchDeckAnalyzer.svg";
import LightModeIcon from "../../assets/icons/LightModeIcon.svg";
import DarkModeIcon from "../../assets/icons/DarkModeIcon.svg";
import MenuDarkIcon from "../../assets/icons/MenuDesktopDark.svg";
import MenuLightIcon from "../../assets/icons/MenuDesktopLight.svg";
import OpenMenuMobile from "../../assets/icons/OpenMenuMobile.svg";
import CloseMenuMobile from "../../assets/icons/CloseMenuMobile.svg";
import OpenMenuMobileDark from "../../assets/icons/OpenMenuMobileDark.svg";
import CloseMenuMobileDark from "../../assets/icons/CloseMenuMobileDark.svg";
import { strings } from "../../translations/strings";

const Header = ({ data }) => {
  const {
    changeScreen,
    SCREENS,
    toggleDarkMode,
    colors,
    onPressMenu,
    isDarkMode,
    isMenuOpened,
  } = data;
  return (
    <div
      className="header-container"
      style={{
        backgroundColor: colors.componentBackground,
        borderBottomColor: colors.borderColor,
      }}
    >
      <div className="header-left-icons">
        <img
          src={isDarkMode ? LogoDarkMode : LogoLightMode}
          alt="Logo"
          className="header-logo-icon-desktop"
          draggable="false"
          onClick={() => changeScreen(SCREENS.HOME)}
        />
        <img
          src={LogoMobile}
          alt="Logo"
          className="header-logo-icon-mobile"
          draggable="false"
          onClick={() => changeScreen(SCREENS.HOME)}
        />
        <div
          className="header-tab"
          onClick={() => changeScreen(SCREENS.IDEA_VALIDATOR)}
        >
          <img
            src={IdeaValidator}
            alt="Idea Validator"
            className="header-icon-desktop"
            draggable="false"
          />
          <p className="header-tab-title" style={{ color: colors.tabText }}>
            {strings.idea_validator_title}
          </p>
        </div>
        <div
          className="header-vertical-line"
          style={{ backgroundColor: colors.borderColor }}
        />
        <div
          className="header-tab"
          onClick={() => changeScreen(SCREENS.MARKET_INSIGHTS)}
        >
          <img
            src={MarketInsights}
            alt="Market Insights"
            className="header-icon-desktop"
            draggable="false"
          />
          <p className="header-tab-title" style={{ color: colors.tabText }}>
            {strings.market_insights_title}
          </p>
        </div>
        <div
          className="header-vertical-line"
          style={{ backgroundColor: colors.borderColor }}
        />
        <div
          className="header-tab"
          onClick={() => changeScreen(SCREENS.PITCH_DECK_ANALYZER)}
        >
          <img
            src={PitchDeckAnalyzer}
            alt="Pitch Deck Analyzer"
            className="header-icon-desktop"
            draggable="false"
          />
          <p className="header-tab-title" style={{ color: colors.tabText }}>
            {strings.pitch_deck_analyzer_title}
          </p>
        </div>
      </div>
      <div className="header-right-icons">
        <img
          src={isDarkMode ? LightModeIcon : DarkModeIcon}
          alt={isDarkMode ? "Dark Mode" : "Light Mode"}
          className="header-mode-switch"
          draggable="false"
          onClick={toggleDarkMode}
        />
        <img
          src={isDarkMode ? MenuDarkIcon : MenuLightIcon}
          alt="Menu"
          className="header-menu-icon-desktop"
          draggable="false"
          onClick={onPressMenu}
        />
        <img
          src={
            isMenuOpened
              ? isDarkMode
                ? CloseMenuMobileDark
                : CloseMenuMobile
              : isDarkMode
                ? OpenMenuMobileDark
                : OpenMenuMobile
          }
          alt="Mobile Menu"
          className="header-menu-icon-mobile"
          draggable="false"
          onClick={onPressMenu}
        />
      </div>
    </div>
  );
};

export default Header;
